import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/motion";
import { FLAGSHIP } from "@/lib/data";
import { useEnquiry } from "@/components/Enquiry";

function Showcase({ data, flip }) {
  const { open } = useEnquiry();
  return (
    <section className="py-20 md:py-28 bg-background" data-testid={`flagship-${data.slug}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        {/* Image side */}
        <Reveal className={flip ? "lg:order-2" : ""}>
          <div className="relative">
            <div className="img-zoom rounded-3xl overflow-hidden shadow-2xl">
              <img src={data.image} alt={data.title} loading="lazy" className="w-full h-[440px] object-cover" />
            </div>
            <div className="grid grid-cols-3 gap-3 mt-3">
              {data.gallery.map((g, i) => (
                <div key={i} className="img-zoom rounded-xl overflow-hidden h-24">
                  <img src={g} alt="" loading="lazy" className="w-full h-full object-cover" />
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        {/* Content side */}
        <div className={flip ? "lg:order-1" : ""}>
          <Reveal><p className="uppercase text-xs tracking-[0.25em] text-primary font-medium mb-3">{data.eyebrow}</p></Reveal>
          <Reveal delay={0.05}><h2 className="font-display text-3xl md:text-5xl font-bold leading-tight mb-5">{data.title}</h2></Reveal>
          <Reveal delay={0.1}><p className="text-muted-foreground leading-relaxed mb-8 max-w-lg">{data.desc}</p></Reveal>
          <div className="grid sm:grid-cols-2 gap-4 mb-9">
            {data.features.map((f, i) => (
              <Reveal key={f.title} delay={0.12 + i * 0.05}>
                <div className="flex items-start gap-3">
                  <span className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0 mt-0.5"><Check className="w-4 h-4 text-primary" /></span>
                  <div><p className="font-medium text-sm">{f.title}</p><p className="text-xs text-muted-foreground">{f.desc}</p></div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <div className="flex flex-wrap gap-3">
              <Button onClick={() => open({ project_type: data.title, source: `flagship-${data.slug}` })} data-testid={`flagship-quote-${data.slug}`}
                className="rounded-full bg-primary text-white hover:bg-primary/90 px-6 h-11">Get Free Design Quote <ArrowRight className="w-4 h-4 ml-2" /></Button>
              <Button asChild variant="outline" className="rounded-full h-11 px-6">
                <Link to={`/services/${data.slug}`} data-testid={`flagship-view-${data.slug}`}>View Details</Link>
              </Button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export function KitchenShowcase() {
  return <Showcase data={FLAGSHIP.kitchen} flip={false} />;
}
export function WardrobeShowcase() {
  return <Showcase data={FLAGSHIP.wardrobe} flip={true} />;
}
